import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/shared/toast/alert.service';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { AvailabilityService } from './../availability.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as  moment from "moment";

declare var availabilityObject: any;
@Component({
  selector: 'app-add-availability',
  templateUrl: './add-availability.component.html',
  styleUrls: ['./add-availability.component.css']
})
export class AddAvailabilityComponent implements OnInit {
  availabilityForm: FormGroup
  availability: any
  dateFormat = ""
  error: any
  title: any = "Availability"
  constructor(
    private _ngZone: NgZone,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private availabilityService: AvailabilityService,
    private loadingService: CustomLoadingService,
    private router: Router,
    private alertService: AlertService,
    private translateService: TranslateService
  ) {
    window["angularComponentRef"] = { component: this, zone: _ngZone };
    this.availabilityForm = this.formBuilder.group({
      ProviderStatusId: [0],
      FromDate: ['', Validators.compose([Validators.required])],
      ToDate: ['', Validators.compose([Validators.required])],
      Notes: ['', Validators.compose([Validators.required])],
    });
  }

  ngOnInit(): void {
    this.activatedRoute.data.subscribe((data: { availability: any }) => {
      this.availability = data.availability;
      if (this.availability) {
        this.availabilityForm.controls["FromDate"].setValue(moment(this.availability.FromDate).format("MM/DD/YYYY"))
        this.availabilityForm.controls["ToDate"].setValue(moment(this.availability.ToDate).format("MM/DD/YYYY"))
        this.availabilityForm.controls["Notes"].setValue(this.availability.Notes)
        this.availabilityForm.controls["ProviderStatusId"].setValue(this.availability.ProviderStatusId)
      }
      availabilityObject.initializeDates(this.availabilityForm.controls["FromDate"].value, this.availabilityForm.controls["ToDate"].value);
    });
  }
  setDate(date: any, fieldName: any) {

    this.availabilityForm.controls[fieldName].setValue(date);


  }
  AddAvailability(model: any) {
    console.log(model);
    if (this.availabilityForm.valid) {
      this.loadingService.show();
      this.availabilityService.add(model).subscribe(res => {
        this.alertService.success(this.translateService.instant("RecordSaved"), { keepAfterRouteChange: true });
        this.router.navigate(["/availability"]);

      }, (error) => {
     
        this.alertService.success(this.translateService.instant("GenericError"), { keepAfterRouteChange: true });

        this.loadingService.hide();
      }, () => {
        this.loadingService.hide();
      })
    }
  }

}
